import styled from 'styled-components';

export const StyledFileUploader = styled.div`
  display: inline-block;
`;